var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _g3, _path12, _g4, _path13, _g5, _path14, _path15, _g6, _path16, _path17, _path18, _g7, _path19, _path20, _g8, _path21, _g9, _path22, _g10, _path23, _path24, _path25, _path26, _path27, _g11, _path28, _g12, _path29, _g13, _path30, _g14, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g15, _path38, _path39, _g16, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageErrorUnicorn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 344,
    viewBox: "0 0 344 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7168 156.045C46.6464 100.097 57.62 34.73 227.467 54.9985C348.238 69.4121 326.972 163.138 325.672 217.463C325.259 234.628 318.977 288.726 302.775 299.025C237.078 340.773 66.7291 316.225 28.8753 269.744C11.7097 248.67 20.3373 198.687 31.7168 156.045Z",
    fill: "#283897"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5043 264.632C-8.09089 231.457 107.493 191.443 170.562 194.883C256.163 199.554 316.494 236.472 300.794 276.645C284.165 319.225 107.06 302.734 45.5043 264.632Z",
    fill: "#2A9DD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.737 213.576C217.745 232.833 194.463 229.888 188.677 221.034C184.859 215.2 194.793 209.73 203.283 209.819C213.431 209.93 215.881 216.39 226.737 213.576Z",
    fill: "#FBD69B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.605 199.554C152.605 199.554 121.865 202.857 119.643 206.661C117.421 210.466 118.556 219.059 123.544 225.065C127.445 229.757 132.529 229.551 137.228 227.308C141.928 225.065 160.38 211.739 160.38 211.739L152.605 199.554Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 199,
    width: 43,
    height: 30
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.605 199.554C152.605 199.554 121.865 202.857 119.643 206.661C117.421 210.466 118.556 219.059 123.544 225.065C127.445 229.757 132.529 229.551 137.228 227.308C141.928 225.065 160.38 211.739 160.38 211.739L152.605 199.554Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.731 196.905C111.731 196.905 123.874 190.851 132.502 217.325C141.129 243.799 133.307 247.019 133.307 247.019C133.307 247.019 113.259 242.451 111.731 223.923C110.204 205.395 111.731 196.905 111.731 196.905Z",
    fill: "#C3ACD3"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.098 137.036C265.939 168.505 234.285 184.308 207.955 167.122C181.625 149.936 183.779 102.085 191.869 90.4031C200.6 77.7989 235.158 76.8289 226.201 115.267C217.25 153.713 256.982 150.527 260.098 137.036Z",
    fill: "#6E7FC7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.943 89.0612C203.098 77.7849 234.828 78.2459 226.201 115.274C217.25 153.713 256.975 150.534 260.098 137.042C257.883 170.514 224.474 173.63 208.842 151.827C193.631 130.596 207.054 108.298 192.943 89.0612Z",
    fill: "#C7A9B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.06 88.9307C203.331 77.7851 234.794 78.3836 226.207 115.267C217.257 153.706 256.982 150.527 260.105 137.036C255.723 169.22 211.099 157.579 215.138 124.211C217.8 102.243 215.227 89.2196 193.06 88.9307Z",
    fill: "#FBD69B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.937 138.047L175.406 167.15C175.406 167.15 148.408 180.69 150.7 203.531C152.991 226.373 196.851 230.563 210.136 225.231C223.421 219.899 211.45 130.782 206.207 122.044C200.958 113.307 177.937 138.047 177.937 138.047Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 120,
    width: 67,
    height: 108
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M177.937 138.047L175.406 167.15C175.406 167.15 148.408 180.69 150.7 203.531C152.991 226.373 196.851 230.563 210.136 225.231C223.421 219.899 211.45 130.782 206.207 122.044C200.958 113.307 177.937 138.047 177.937 138.047Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.031 148.285C165.031 148.285 163.531 167.294 184.983 169.936C230.342 175.516 227.102 122.554 221.88 119.912C211.808 114.814 165.031 144.109 165.031 144.109V148.285Z",
    fill: "#E1E4F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 120,
    width: 67,
    height: 108
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.937 138.047L175.406 167.15C175.406 167.15 148.408 180.69 150.7 203.531C152.991 226.373 196.851 230.563 210.136 225.231C223.421 219.899 211.45 130.782 206.207 122.044C200.958 113.307 177.937 138.047 177.937 138.047Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.894 220.408C155.894 220.408 150.232 209.069 157.029 207.377C163.827 205.684 192.688 212.282 193.06 219.898C193.431 227.515 192.943 238.681 192.943 238.681L155.894 220.408Z",
    fill: "#E1E4F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 120,
    width: 67,
    height: 108
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M177.937 138.047L175.406 167.15C175.406 167.15 148.408 180.69 150.7 203.531C152.991 226.373 196.851 230.563 210.136 225.231C223.421 219.899 211.45 130.782 206.207 122.044C200.958 113.307 177.937 138.047 177.937 138.047Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.953 183.084C202.953 183.084 201.323 203.091 205.079 207.763C208.829 212.427 217.91 211.244 217.91 211.244L218.674 199.562L213.734 184.556L202.953 183.084Z",
    fill: "#E1E4F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 120,
    width: 67,
    height: 108
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M177.937 138.047L175.406 167.15C175.406 167.15 148.408 180.69 150.7 203.531C152.991 226.373 196.851 230.563 210.136 225.231C223.421 219.899 211.45 130.782 206.207 122.044C200.958 113.307 177.937 138.047 177.937 138.047Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.528 192.124C150.528 192.124 152.151 192.909 157.332 193.796C162.512 194.677 172.261 178.44 172.261 178.44L153.472 183.084L150.528 192.124Z",
    fill: "#E1E4F7"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M169.585 170.893C169.585 170.893 148.642 174.732 147.308 177.463C145.973 180.194 147.191 186.035 150.927 189.902C153.851 192.929 157.325 192.523 160.442 190.741C163.558 188.959 175.543 178.867 175.543 178.867L169.585 170.893Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 170,
    width: 30,
    height: 23
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M169.585 170.893C169.585 170.893 148.642 174.732 147.308 177.463C145.973 180.194 147.191 186.035 150.927 189.902C153.851 192.929 157.325 192.523 160.442 190.741C163.558 188.959 175.543 178.867 175.543 178.867L169.585 170.893Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.37 171.161C141.37 171.161 149.399 166.379 156.685 184.123C163.971 201.866 158.756 204.481 158.756 204.481C158.756 204.481 144.748 202.368 142.753 189.716C140.758 177.064 141.37 171.161 141.37 171.161Z",
    fill: "#C3ACD3"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.826 66.4678C179.623 73.9188 189.874 86.0551 185.327 98.5354C183.421 103.764 175.117 105.814 171.532 98.845C167.026 90.0937 167.335 79.0857 172.826 66.4678Z",
    fill: "#D6EFFC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M200.875 129.846C218.364 113.561 197.346 88.6763 170.7 93.4029C151.793 96.7534 134.47 114.297 137.6 130.981C140.558 146.73 152.048 152.495 160.104 152.605C173.596 152.791 177.814 140.916 187.831 135.859C193.259 133.128 196.747 133.692 200.875 129.846Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 137,
    y: 92,
    width: 71,
    height: 61
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M200.875 129.846C218.364 113.561 197.346 88.6763 170.7 93.4029C151.793 96.7534 134.47 114.297 137.6 130.981C140.558 146.73 152.048 152.495 160.104 152.605C173.596 152.791 177.814 140.916 187.831 135.859C193.259 133.128 196.747 133.692 200.875 129.846Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.583 139.258C124.439 138.783 142.581 111.084 149.626 120.661C151.03 122.567 153.369 123.551 155.722 123.31C163.957 122.457 179.733 124.686 169.688 157.545C152.853 212.654 124.583 139.258 124.583 139.258Z",
    fill: "#E1E4F7"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M161.542 142.506C159.086 134.091 147.755 134.091 144.06 136.72C142.96 137.504 143.668 139.251 144.996 139.017C146.916 138.68 149.31 138.873 152 139.65C153.72 140.146 156.892 144.205 157.965 144.934C159.313 145.849 162.003 144.074 161.542 142.506Z",
    fill: "#33303D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 135,
    width: 19,
    height: 11
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M161.542 142.506C159.086 134.091 147.755 134.091 144.06 136.72C142.96 137.504 143.668 139.251 144.996 139.017C146.916 138.68 149.31 138.873 152 139.65C153.72 140.146 156.892 144.205 157.965 144.934C159.313 145.849 162.003 144.074 161.542 142.506Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.461 140.538C149.461 140.538 147.617 137.875 149.344 137.408C151.071 136.947 154.098 136.96 154.621 138.983C155.144 141.006 152.736 144.81 152.736 144.81L149.461 140.538Z",
    fill: "#D5598B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 135,
    width: 19,
    height: 11
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M161.542 142.506C159.086 134.091 147.755 134.091 144.06 136.72C142.96 137.504 143.668 139.251 144.996 139.017C146.916 138.68 149.31 138.873 152 139.65C153.72 140.146 156.892 144.205 157.965 144.934C159.313 145.849 162.003 144.074 161.542 142.506Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.855 136.671L150.28 136.176C149.97 136.08 149.805 135.749 149.901 135.447L150.631 133.121C150.727 132.812 151.057 132.646 151.36 132.743L152.935 133.238C153.245 133.334 153.41 133.665 153.314 133.967L152.585 136.293C152.488 136.596 152.165 136.768 151.855 136.671Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 135,
    width: 19,
    height: 11
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M161.542 142.506C159.086 134.091 147.755 134.091 144.06 136.72C142.96 137.504 143.668 139.251 144.996 139.017C146.916 138.68 149.31 138.873 152 139.65C153.72 140.146 156.892 144.205 157.965 144.934C159.313 145.849 162.003 144.074 161.542 142.506Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.254 137.965L153.734 137.325C153.438 137.201 153.3 136.857 153.424 136.561L154.373 134.318C154.497 134.023 154.841 133.885 155.137 134.009L156.658 134.649C156.953 134.773 157.091 135.117 156.967 135.412L156.018 137.655C155.894 137.951 155.55 138.089 155.254 137.965Z",
    fill: "white"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M146.613 126.599C146.386 127.177 145.677 127.438 145.03 127.184C144.384 126.929 143.875 126.31 144.102 125.732C144.329 125.154 144.735 124.748 145.381 125.003C146.035 125.25 146.84 126.021 146.613 126.599Z",
    fill: "#44555E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M157.421 128.828C157.167 129.392 157.469 130.08 158.102 130.369C158.735 130.658 159.533 130.59 159.788 130.025C160.043 129.461 160.049 128.883 159.417 128.594C158.79 128.305 157.676 128.264 157.421 128.828Z",
    fill: "#44555E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.387 69.8594C160.022 95.8451 186.331 104.596 197.064 97.7715C204.143 93.272 196.383 82.0783 187.301 77.7989C176.431 72.6871 170.486 78.5832 160.387 69.8594Z",
    fill: "#FBD69B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M185.98 88.2773L205.313 22.2637C205.733 20.8327 207.838 21.1216 207.852 22.6146L208.732 91.6691C208.822 98.4803 202.472 103.551 195.846 101.968L193.603 101.432C187.776 100.028 184.295 94.0359 185.98 88.2773Z",
    fill: "#FFE600"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 21,
    width: 24,
    height: 82
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M185.98 88.2773L205.313 22.2637C205.733 20.8327 207.838 21.1216 207.852 22.6146L208.732 91.6691C208.822 98.4803 202.472 103.551 195.846 101.968L193.603 101.432C187.776 100.028 184.295 94.0359 185.98 88.2773Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.596 35.9616C210.672 35.9616 205.96 34.1935 202.568 30.6915C195.984 23.8941 196.851 13.1131 196.892 12.6591C196.947 12.0261 197.484 11.5651 198.13 11.6202C198.763 11.6752 199.224 12.2325 199.169 12.8586C199.162 12.9618 198.364 23.0754 204.219 29.1091C207.453 32.4459 212.165 33.9664 218.22 33.6293C218.867 33.5949 219.396 34.0765 219.431 34.7095C219.465 35.3424 218.984 35.8791 218.351 35.9203C217.752 35.9479 217.167 35.9616 216.596 35.9616Z",
    fill: "#B3B309"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 21,
    width: 24,
    height: 82
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M185.98 88.2773L205.313 22.2637C205.733 20.8327 207.838 21.1216 207.852 22.6146L208.732 91.6691C208.822 98.4803 202.472 103.551 195.846 101.968L193.603 101.432C187.776 100.028 184.295 94.0359 185.98 88.2773Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.548 51.2902C207.625 51.2902 202.912 49.5221 199.52 46.0202C192.936 39.2227 193.803 28.4418 193.844 27.9877C193.899 27.3547 194.436 26.8938 195.082 26.9488C195.715 27.0038 196.176 27.5611 196.121 28.1872C196.114 28.2904 195.316 38.404 201.171 44.4378C204.405 47.7746 209.118 49.295 215.172 48.9579C215.826 48.9304 216.348 49.4051 216.383 50.0381C216.417 50.671 215.936 51.2077 215.303 51.249C214.704 51.2696 214.119 51.2902 213.548 51.2902Z",
    fill: "#B3B309"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 21,
    width: 24,
    height: 82
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M185.98 88.2773L205.313 22.2637C205.733 20.8327 207.838 21.1216 207.852 22.6146L208.732 91.6691C208.822 98.4803 202.472 103.551 195.846 101.968L193.603 101.432C187.776 100.028 184.295 94.0359 185.98 88.2773Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.638 65.3049C204.714 65.3049 200.002 63.5367 196.61 60.0348C190.026 53.2374 190.892 42.4564 190.934 42.0023C190.989 41.3694 191.525 40.9084 192.172 40.9634C192.805 41.0185 193.266 41.5758 193.211 42.2018C193.204 42.305 192.406 52.4186 198.261 58.4524C201.495 61.7892 206.207 63.3028 212.262 62.9726C212.908 62.9382 213.438 63.4198 213.473 64.0527C213.507 64.6857 213.025 65.2223 212.392 65.2636C211.794 65.2842 211.209 65.3049 210.638 65.3049Z",
    fill: "#B3B309"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 21,
    width: 24,
    height: 82
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M185.98 88.2773L205.313 22.2637C205.733 20.8327 207.838 21.1216 207.852 22.6146L208.732 91.6691C208.822 98.4803 202.472 103.551 195.846 101.968L193.603 101.432C187.776 100.028 184.295 94.0359 185.98 88.2773Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.312 82.0851C211.285 82.0851 211.257 82.0851 211.23 82.0851C183.923 80.2619 182.87 56.1613 182.864 55.9136C182.843 55.2256 183.386 54.6477 184.074 54.627C184.776 54.6201 185.34 55.1499 185.361 55.8379C185.395 56.7598 186.407 77.9227 211.395 79.5945C212.083 79.6427 212.606 80.2344 212.558 80.9224C212.516 81.576 211.966 82.0851 211.312 82.0851Z",
    fill: "#B3B309"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.478 80.269C167.528 107.865 198.185 108.58 207.322 97.8818C213.342 90.8298 201.508 81.5143 190.514 79.9319C177.36 78.0467 172.991 86.2202 159.478 80.269Z",
    fill: "#6E7FC7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.884 101.164C226.139 109.454 216.589 122.148 203.407 120.503C197.883 119.815 194.037 112.172 200.029 107.129C207.563 100.778 218.357 98.625 231.884 101.164Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.435 102.492C222.52 108.133 216.018 116.781 207.047 115.66C203.283 115.192 200.662 109.984 204.742 106.551C209.874 102.23 217.222 100.765 226.435 102.492Z",
    fill: "#D6EFFC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M159.217 107.906C159.148 107.906 159.072 107.899 159.004 107.885L152.364 106.626C151.745 106.509 151.346 105.918 151.463 105.299C151.58 104.679 152.179 104.28 152.791 104.397L159.43 105.656C160.049 105.773 160.448 106.365 160.332 106.984C160.221 107.528 159.747 107.906 159.217 107.906Z",
    fill: "#33303D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M171.69 112.488C171.106 112.488 170.61 112.041 170.562 111.449C170.507 110.823 170.975 110.273 171.601 110.225L181.618 109.378C182.237 109.323 182.795 109.791 182.843 110.417C182.898 111.043 182.43 111.594 181.811 111.642L171.794 112.488C171.752 112.488 171.725 112.488 171.69 112.488Z",
    fill: "#33303D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M202.953 179.238C202.953 179.238 203.139 205.244 206.145 207.425C209.145 209.606 216.431 209.372 221.873 205.698C226.132 202.822 226.38 198.557 224.893 194.429C223.407 190.308 213.803 173.748 213.803 173.748L202.953 179.238Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 202,
    y: 173,
    width: 24,
    height: 36
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M202.953 179.238C202.953 179.238 203.139 205.244 206.145 207.425C209.145 209.606 216.431 209.372 221.873 205.698C226.132 202.822 226.38 198.557 224.893 194.429C223.407 190.308 213.803 173.748 213.803 173.748L202.953 179.238Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.312 213.232C197.312 213.232 193.259 202.561 216.142 197.553C239.025 192.544 241.061 199.369 241.061 199.369C241.061 199.369 235.557 215.771 219.919 215.496C204.281 215.22 197.312 213.232 197.312 213.232Z",
    fill: "#C3ACD3"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M195.495 219.231C195.495 219.231 199.121 240.828 201.219 244.708C205.451 252.53 211.649 251.436 218.681 248.038C224.632 245.155 227.24 236.411 224.563 231.939C221.887 227.467 206.895 210.349 206.895 210.349L195.495 219.231Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_20262_118684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 195,
    y: 210,
    width: 31,
    height: 41
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M195.495 219.231C195.495 219.231 199.121 240.828 201.219 244.708C205.451 252.53 211.649 251.436 218.681 248.038C224.632 245.155 227.24 236.411 224.563 231.939C221.887 227.467 206.895 210.349 206.895 210.349L195.495 219.231Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_20262_118684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.352 264.089C200.352 264.089 193.479 242.775 210.611 234.519C227.742 226.27 239.032 238.839 239.032 238.839C239.032 238.839 241.22 250.143 223.703 256.459C206.187 262.775 200.352 264.089 200.352 264.089Z",
    fill: "#C3ACD3"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4172 251.705C90.7344 251.705 93.4235 249.016 93.4235 245.699C93.4235 242.381 90.7344 239.692 87.4172 239.692C84.1001 239.692 81.411 242.381 81.411 245.699C81.411 249.016 84.1001 251.705 87.4172 251.705Z",
    fill: "#56BBE9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M110.08 249.462C113.397 249.462 116.086 246.773 116.086 243.455C116.086 240.138 113.397 237.449 110.08 237.449C106.763 237.449 104.074 240.138 104.074 243.455C104.074 246.773 106.763 249.462 110.08 249.462Z",
    fill: "#56BBE9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M231.904 284.935C235.221 284.935 237.91 282.246 237.91 278.929C237.91 275.612 235.221 272.923 231.904 272.923C228.587 272.923 225.898 275.612 225.898 278.929C225.898 282.246 228.587 284.935 231.904 284.935Z",
    fill: "#56BBE9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M255.055 281.75C258.372 281.75 261.062 279.061 261.062 275.744C261.062 272.426 258.372 269.737 255.055 269.737C251.738 269.737 249.049 272.426 249.049 275.744C249.049 279.061 251.738 281.75 255.055 281.75Z",
    fill: "#56BBE9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M256.163 285.933C255.021 285.933 254.078 285.018 254.058 283.869C252.262 196.045 232.406 154.717 216.073 135.508C198.605 114.971 181.398 114.82 181.192 114.82C180.05 114.813 179.079 113.891 179.066 112.729C179.052 111.566 179.981 110.616 181.143 110.603C181.907 110.589 200.215 110.61 218.942 132.378C229.764 144.955 238.53 162.292 244.976 183.902C252.991 210.741 257.463 244.343 258.268 283.779C258.289 284.942 257.367 285.905 256.204 285.933C256.197 285.933 256.177 285.933 256.163 285.933Z",
    fill: "#FF0303"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M251.87 286.208C250.707 286.208 249.765 285.265 249.765 284.102C249.551 189.64 227.604 148.216 209.228 130.1C193.734 114.827 179.644 114.786 179.513 114.82C179.506 114.82 179.499 114.82 179.485 114.82C178.336 114.82 177.394 113.891 177.38 112.735C177.366 111.573 178.295 110.616 179.465 110.603C179.479 110.603 179.499 110.603 179.52 110.603C180.738 110.603 195.798 110.94 212.186 127.101C231.127 145.78 253.755 188.175 253.975 284.096C253.982 285.265 253.04 286.208 251.87 286.208C251.877 286.208 251.877 286.208 251.87 286.208Z",
    fill: "#F99023"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M247.584 286.49C247.577 286.49 247.563 286.49 247.556 286.49C246.393 286.476 245.465 285.52 245.478 284.35C246.765 190.046 225.554 148.553 207.535 130.348C192.323 114.978 178.027 114.82 177.834 114.82H177.827C176.671 114.82 175.722 113.884 175.715 112.728C175.708 111.566 176.637 110.616 177.8 110.609C178.46 110.616 193.837 110.63 210.349 127.197C229.021 145.931 251.003 188.408 249.696 284.412C249.675 285.561 248.733 286.49 247.584 286.49Z",
    fill: "#FDEE2E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M243.291 286.765C243.277 286.765 243.263 286.765 243.256 286.765C242.093 286.744 241.165 285.788 241.185 284.619C242.692 197.841 224.776 156.238 209.482 136.623C193.128 115.646 176.245 114.827 176.073 114.82C174.91 114.779 174.002 113.809 174.036 112.646C174.071 111.483 175.048 110.575 176.197 110.603C176.954 110.623 194.91 111.366 212.482 133.609C222.63 146.461 230.569 163.93 236.094 185.526C242.947 212.351 246.084 245.712 245.403 284.68C245.375 285.843 244.433 286.765 243.291 286.765Z",
    fill: "#8BC645"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M238.997 287.04C238.984 287.04 238.97 287.04 238.956 287.04C237.793 287.019 236.865 286.056 236.885 284.894C238.488 199.368 221.268 157.627 206.531 137.668C190.762 116.313 174.463 114.827 174.305 114.82C173.149 114.73 172.275 113.726 172.358 112.563C172.44 111.407 173.445 110.534 174.601 110.616C175.33 110.664 192.681 112.102 209.592 134.724C219.362 147.789 226.992 165.319 232.283 186.826C238.853 213.548 241.818 246.565 241.103 284.976C241.082 286.125 240.14 287.04 238.997 287.04Z",
    fill: "#2CAAE3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M234.945 287.302C234.918 287.302 234.89 287.302 234.863 287.302C233.7 287.261 232.792 286.277 232.833 285.114C235.915 202.609 219.259 160.641 204.742 139.967C189.166 117.785 172.702 114.82 172.537 114.793C171.388 114.6 170.61 113.52 170.796 112.371C170.982 111.229 172.055 110.445 173.204 110.63C173.933 110.747 191.298 113.747 207.893 137.118C217.497 150.644 224.887 168.298 229.847 189.571C236.011 216.018 238.433 248.217 237.05 285.265C237.009 286.414 236.073 287.302 234.945 287.302Z",
    fill: "#693091"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5476 255.641C89.495 255.641 88.6144 254.808 88.5731 253.742C86.9288 211.113 89.667 176.954 96.719 152.2C102.285 132.661 110.527 118.921 121.219 111.374C136.313 100.71 150.651 106.228 151.25 106.468C152.261 106.874 152.757 108.023 152.351 109.035C151.945 110.046 150.803 110.541 149.791 110.142C149.234 109.922 136.719 105.202 123.413 114.662C107.314 126.104 88.8827 159.499 92.5153 253.597C92.5566 254.684 91.7104 255.606 90.6164 255.647C90.6027 255.641 90.5752 255.641 90.5476 255.641Z",
    fill: "#FF0303"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3248 255.64C93.2859 255.64 92.4121 254.828 92.3571 253.776C90.0316 211.237 92.2195 177.126 98.8449 152.385C104.081 132.832 112.089 119.065 122.636 111.47C137.621 100.675 152.124 106.227 152.729 106.468C153.74 106.867 154.243 108.016 153.837 109.027C153.438 110.039 152.296 110.534 151.277 110.142C150.741 109.936 138.061 105.168 124.858 114.731C109 126.221 91.1668 159.637 96.2924 253.562C96.3544 254.65 95.515 255.585 94.428 255.64C94.3936 255.64 94.3592 255.64 94.3248 255.64Z",
    fill: "#F99023"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M98.095 255.64C97.063 255.64 96.1961 254.842 96.1273 253.803C93.2102 211.278 94.8958 177.167 101.143 152.434C106.083 132.874 113.857 119.1 124.26 111.491C139.045 100.675 153.589 106.227 154.201 106.468C155.213 106.867 155.715 108.016 155.309 109.028C154.91 110.039 153.768 110.534 152.75 110.142C152.213 109.936 139.519 105.161 126.516 114.731C110.892 126.221 93.623 159.63 100.07 253.535C100.145 254.622 99.3265 255.565 98.2326 255.64C98.1844 255.64 98.1432 255.64 98.095 255.64Z",
    fill: "#FDEE2E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M101.872 255.64C100.847 255.64 99.9801 254.849 99.9044 253.81C96.8566 211.484 98.4046 177.497 104.493 152.798C109.289 133.341 116.898 119.595 127.094 111.931C141.226 101.315 155.048 106.241 155.632 106.454C156.658 106.833 157.18 107.968 156.802 108.993C156.424 110.011 155.295 110.541 154.27 110.163C153.747 109.977 141.762 105.801 129.392 115.151C114.036 126.764 97.1318 160.194 103.854 253.528C103.929 254.615 103.11 255.564 102.023 255.64C101.962 255.64 101.913 255.64 101.872 255.64Z",
    fill: "#8BC645"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M105.642 255.64C104.617 255.64 103.75 254.849 103.675 253.81C100.586 211.608 102.051 177.697 108.03 153.018C112.715 133.672 120.152 119.967 130.135 112.275C143.531 101.955 156.513 106.248 157.057 106.434C158.089 106.791 158.639 107.913 158.281 108.945C157.923 109.977 156.802 110.527 155.777 110.169C155.261 109.997 144.115 106.427 132.454 115.474C117.373 127.177 100.819 160.62 107.617 253.521C107.699 254.608 106.881 255.558 105.794 255.633C105.739 255.64 105.691 255.64 105.642 255.64Z",
    fill: "#2CAAE3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M109.206 255.64C108.195 255.64 107.335 254.87 107.245 253.844C103.613 213.342 104.597 180.421 110.156 155.997C114.518 136.843 121.673 122.897 131.415 114.531C144.631 103.193 157.724 106.255 158.281 106.392C159.341 106.654 159.987 107.72 159.726 108.78C159.465 109.839 158.398 110.486 157.339 110.224C156.83 110.101 145.512 107.569 133.885 117.614C119.113 130.383 103.186 164.315 111.181 253.494C111.277 254.581 110.479 255.537 109.392 255.633C109.323 255.64 109.261 255.64 109.206 255.64Z",
    fill: "#693091"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M183.827 208.664H138.653V253.838H183.827V208.664Z",
    fill: "#131A46"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M183.827 208.663H138.653L159.843 196.789H195.509L183.827 208.663Z",
    fill: "#54557B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M183.827 253.838L196.279 235L195.509 196.789L183.827 208.663V253.838Z",
    fill: "#131A46"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M185.044 219.018L195.426 208.313V206.634L185.044 217.112V219.018Z",
    fill: "#54557B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M158.811 226.607C159.031 226.827 159.031 227.192 158.811 227.412L155.908 230.315C155.687 230.535 155.323 230.535 155.103 230.315L153.163 228.375L151.945 227.157L148.787 230.315C148.567 230.535 148.202 230.535 147.982 230.315L147.865 230.198L147.136 229.469L145.079 227.412C144.858 227.192 144.858 226.827 145.079 226.607L148.236 223.449L145.079 220.291C144.858 220.071 144.858 219.706 145.079 219.486L147.982 216.583C148.202 216.362 148.567 216.362 148.787 216.583L151.945 219.741L155.103 216.583C155.323 216.362 155.687 216.362 155.908 216.583L158.811 219.486C159.031 219.706 159.031 220.071 158.811 220.291L155.653 223.449L158.811 226.607Z",
    fill: "#D52629"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M177.676 226.607C177.896 226.827 177.896 227.192 177.676 227.412L174.773 230.315C174.552 230.535 174.188 230.535 173.968 230.315L172.027 228.375L170.81 227.157L167.652 230.315C167.432 230.535 167.067 230.535 166.847 230.315L166.73 230.198L166.001 229.469L163.943 227.412C163.723 227.192 163.723 226.827 163.943 226.607L167.101 223.449L163.943 220.291C163.723 220.071 163.723 219.706 163.943 219.486L166.847 216.583C167.067 216.362 167.432 216.362 167.652 216.583L170.81 219.741L173.968 216.583C174.188 216.362 174.552 216.362 174.773 216.583L177.676 219.486C177.896 219.706 177.896 220.071 177.676 220.291L174.518 223.449L177.676 226.607Z",
    fill: "#D52629"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M150.404 244.969L147.624 244.949C147.624 244.632 147.769 237.119 160.38 237.119C172.888 237.119 173.589 244.061 173.617 244.357L170.844 244.584C170.824 244.419 170.156 239.906 160.38 239.906C150.679 239.899 150.411 244.763 150.404 244.969Z",
    fill: "#D52629"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M173.713 201.742C173.713 204.13 172.261 203.834 169.537 203.827C167.232 203.82 165.361 204.047 165.361 201.742C165.361 199.438 167.232 198.117 169.537 198.117C171.842 198.117 173.713 199.438 173.713 201.742Z",
    fill: "#131A46"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M170.927 199.444L169.544 199.259L169.915 196.534L167.06 195.027L167.5 191.821L164.638 190.315L165.141 186.627L166.517 186.813L166.145 189.537L169.007 191.051L168.567 194.25L171.429 195.757L170.927 199.444Z",
    fill: "#131A46"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M167.156 199.726C166.668 200.132 166.324 200.524 166.2 200.373C166.076 200.222 166.372 199.774 166.861 199.369C167.349 198.963 167.844 198.756 167.968 198.908C168.092 199.059 167.645 199.32 167.156 199.726Z",
    fill: "#E1E4F7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M166.166 188.278C167.993 188.278 169.475 186.797 169.475 184.969C169.475 183.141 167.993 181.66 166.166 181.66C164.338 181.66 162.856 183.141 162.856 184.969C162.856 186.797 164.338 188.278 166.166 188.278Z",
    fill: "#D52629",
    stroke: "#D52629",
    strokeWidth: 1.2113,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M165.244 185.189C165.878 185.189 166.393 184.675 166.393 184.04C166.393 183.406 165.878 182.891 165.244 182.891C164.609 182.891 164.095 183.406 164.095 184.04C164.095 184.675 164.609 185.189 165.244 185.189Z",
    fill: "#E1E4F7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0822 257.711C92.3994 257.711 95.0885 255.022 95.0885 251.704C95.0885 248.387 92.3994 245.698 89.0822 245.698C85.7651 245.698 83.076 248.387 83.076 251.704C83.076 255.022 85.7651 257.711 89.0822 257.711Z",
    fill: "#2CAAE3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7053 257.711C100.022 257.711 102.712 255.022 102.712 251.704C102.712 248.387 100.022 245.698 96.7053 245.698C93.3881 245.698 90.699 248.387 90.699 251.704C90.699 255.022 93.3881 257.711 96.7053 257.711Z",
    fill: "#56BBE9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M101.934 261.399C105.251 261.399 107.94 258.71 107.94 255.392C107.94 252.075 105.251 249.386 101.934 249.386C98.6169 249.386 95.9278 252.075 95.9278 255.392C95.9278 258.71 98.6169 261.399 101.934 261.399Z",
    fill: "#2CAAE3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M108.635 257.711C111.952 257.711 114.641 255.022 114.641 251.704C114.641 248.387 111.952 245.698 108.635 245.698C105.318 245.698 102.629 248.387 102.629 251.704C102.629 255.022 105.318 257.711 108.635 257.711Z",
    fill: "#56BBE9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M237.25 287.797C240.202 287.797 242.596 285.404 242.596 282.451C242.596 279.499 240.202 277.105 237.25 277.105C234.297 277.105 231.904 279.499 231.904 282.451C231.904 285.404 234.297 287.797 237.25 287.797Z",
    fill: "#56BBE9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M255.055 287.935C258.692 287.935 261.639 284.987 261.639 281.351C261.639 277.714 258.692 274.767 255.055 274.767C251.419 274.767 248.471 277.714 248.471 281.351C248.471 284.987 251.419 287.935 255.055 287.935Z",
    fill: "#56BBE9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M245.293 293.343C248.929 293.343 251.877 290.395 251.877 286.758C251.877 283.122 248.929 280.174 245.293 280.174C241.656 280.174 238.708 283.122 238.708 286.758C238.708 290.395 241.656 293.343 245.293 293.343Z",
    fill: "#2CAAE3"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M233.934 292.035C236.886 292.035 239.279 289.642 239.279 286.69C239.279 283.737 236.886 281.344 233.934 281.344C230.981 281.344 228.588 283.737 228.588 286.69C228.588 289.642 230.981 292.035 233.934 292.035Z",
    fill: "#2CAAE3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageErrorUnicorn);
export default __webpack_public_path__ + "static/media/image-error-unicorn.004a9a40.svg";
export { ForwardRef as ReactComponent };